import React, { FC } from 'react';
import clsx from 'clsx';

import { RadioButton } from '@marriott/mi-ui-library';

import { ToggleRadioButtonsProps } from './ToggleRadioButtons.types';
import { StyledToggleRadioButtons } from './ToggleRadioButtons.styles';

export const ToggleRadioButtons: FC<ToggleRadioButtonsProps> = ({
  radiobuttonName,
  onChange,
  toggleRadioButtonsContainerClassName,
  value,

  firstRadiobuttonId,
  firstRadiobuttonLabel,
  firstRadioValue,
  firstRadioDisabled,
  firstRadioSetTabIndex,
  firstRadioClassName,
  firstRadioLabelClassName,
  firstRadioDataTestId,
  firstRadioTabIndexForInput,
  firstRadioAriaLabelForLink,

  secondRadiobuttonId,
  secondRadiobuttonLabel,
  secondRadioValue,
  secondRadioDisabled,
  secondRadioSetTabIndex,
  secondRadioClassName,
  secondRadioLabelClassName,
  secondRadioDataTestId,
  secondRadioTabIndexForInput,
  secondRadioAriaLabelForLink,
}) => {
  return (
    <StyledToggleRadioButtons
      data-component-name="m-legal-ToggleRadioButtons"
      data-testid="legal-ToggleRadioButtons"
      className={clsx(toggleRadioButtonsContainerClassName)}
    >
      <RadioButton
        radiobuttonId={firstRadiobuttonId}
        radiobuttonName={radiobuttonName}
        radiobuttonLabel={firstRadiobuttonLabel}
        checked={value === firstRadioValue}
        onChange={() => onChange(firstRadioValue)}
        value={firstRadioValue}
        setTabIndex={firstRadioSetTabIndex}
        disabled={firstRadioDisabled}
        className={firstRadioClassName}
        labelClassName={firstRadioLabelClassName}
        dataTestId={firstRadioDataTestId}
        tabIndexForInput={firstRadioTabIndexForInput}
        ariaLabelForLink={firstRadioAriaLabelForLink}
      />
      <RadioButton
        radiobuttonId={secondRadiobuttonId}
        radiobuttonName={radiobuttonName}
        radiobuttonLabel={secondRadiobuttonLabel}
        checked={value === secondRadioValue}
        onChange={() => onChange(secondRadioValue)}
        value={secondRadioValue}
        setTabIndex={secondRadioSetTabIndex}
        disabled={secondRadioDisabled}
        className={secondRadioClassName}
        labelClassName={secondRadioLabelClassName}
        dataTestId={secondRadioDataTestId}
        tabIndexForInput={secondRadioTabIndexForInput}
        ariaLabelForLink={secondRadioAriaLabelForLink}
      />
    </StyledToggleRadioButtons>
  );
};
